import type { TiptapContent } from "@/react/components/SettingsApp/CommunityInbox/BotChatRoom/MessageBox";

export const buildQuestionContent = (question: string): TiptapContent => ({
  body: {
    body: {
      type: "doc",
      content: [
        { type: "paragraph", content: [{ type: "text", text: question }] },
      ],
    },
    attachments: [],
    localAttachments: [],
    localSgidToObjectMap: {},
  },
});
